/*#######################################
              Importaciones
#########################################*/

//Modulos
import { Link } from 'react-router-dom';
// FaPhoneAlt y FaWhatsapp se usan en el bloque de teléfono comentado (ver RESTAURAR_TELEFONO.md)
// eslint-disable-next-line no-unused-vars
import { FaEnvelope, FaPhoneAlt, FaMapMarkerAlt, FaFacebook, FaInstagram, FaWhatsapp } from 'react-icons/fa';
//Estilos
import './FooterContainer.css';
//Componentes
//Core

/*#######################################
                Logica
#########################################*/
const FooterContainer = () => (
  <footer className="footer">
    <div className="footer-content">
      <div className="footer-section about">
        <h3>Techteno</h3>
        <p>
          <strong>Techteno</strong> (también conocido como <em>Tech Teno</em>) es tu
          tienda online de tecnología en Argentina. Productos originales, atención
          personalizada y envíos a todo el país desde Mendoza.
        </p>
      </div>
      <div className="footer-section links">
        <h4>Enlaces útiles</h4>
        <ul>
          <li><Link to="/">Inicio</Link></li>
          <li><Link to="/productos#categorias">Productos</Link></li>
          <li><Link to="/contacto">Contacto</Link></li>
          <li><Link to="/devoluciones">Devoluciones</Link></li>
        </ul>
      </div>
      <div className="footer-section links">
        <h4>Zonas de envío</h4>
        <ul>
          <li><a href="/mendoza/">Tecnología en Mendoza</a></li>
          <li><a href="/cuyo/">Tecnología en Cuyo (San Juan / San Luis)</a></li>
          <li><a href="/argentina/">Envíos a toda Argentina</a></li>
        </ul>
      </div>
      <div className="footer-section contact">
        <h4>Contacto</h4>
        <p><FaEnvelope aria-hidden="true" /> techtenoit@gmail.com</p>
        {/* TODO: telefono perdido. Restaurar cuando haya linea nueva.
        <p><FaPhoneAlt aria-hidden="true" /> NUEVO_NUMERO</p> */}
        <p><FaMapMarkerAlt aria-hidden="true" /> Mendoza, Argentina</p>
      </div>
      <div className="footer-section social">
        <h4>Seguinos</h4>
        <div className="footer-social-icons">
          <a href="https://www.facebook.com/Techteno.it/" target="_blank" rel="noopener noreferrer" aria-label="Facebook de Techteno"><FaFacebook aria-hidden="true" /></a>
          <a href="https://www.instagram.com/techteno/" target="_blank" rel="noopener noreferrer" aria-label="Instagram de Techteno"><FaInstagram aria-hidden="true" /></a>
          {/* TODO: WhatsApp perdido. Restaurar cuando haya linea nueva.
          <a href="https://wa.me/NUEVO_NUMERO" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp de Techteno"><FaWhatsapp aria-hidden="true" /></a> */}
        </div>
      </div>
    </div>
    <div className="footer-bottom">
      {/* No dice "desarrollado por": Techtenoapp no es una agencia de afuera que
          nos hizo el sitio, es el estudio de software de la misma empresa. Este
          renglon es la unica puerta entre las dos ramas, y el que la cruza es el
          cliente que ya nos compro algo y ahora necesita que le hagamos algo. */}
      &copy; {new Date().getFullYear()} Techteno. Todos los derechos reservados. También hacemos apps, sitios y sistemas a medida en <a href="https://techtenoapp.com" target="_blank" rel="noopener noreferrer">Techtenoapp</a>, nuestro estudio de software.
    </div>
  </footer>
);

/*#######################################
              Exportaciones
#########################################*/
export default FooterContainer;